import React from "react";
import { Link } from "react-router";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../app/components/ui/card";
import { Button } from "../../app/components/ui/button";
import { useAuth } from "../../providers/AuthProvider";

export function AdminProfilePage() {
  const { user, lastLoginAt, sessionStartedAt, logout } = useAuth();

  return (
    <div className="p-6 space-y-6 max-w-lg">
      <div>
        <h1 className="text-3xl font-semibold text-foreground mb-1">Profile</h1>
        <p className="text-muted-foreground">Signed-in super admin session (mock).</p>
      </div>

      <Card className="border-0 shadow-sm">
        <CardHeader>
          <CardTitle>Account</CardTitle>
          <CardDescription>Identity and session details</CardDescription>
        </CardHeader>
        <CardContent className="space-y-3 text-sm">
          <div>
            <div className="text-muted-foreground">Name</div>
            <div className="font-medium">{user?.name ?? "—"}</div>
          </div>
          <div>
            <div className="text-muted-foreground">Email</div>
            <div className="font-medium">{user?.email ?? "—"}</div>
          </div>
          <div>
            <div className="text-muted-foreground">Role</div>
            <div className="font-medium capitalize">{user?.role ?? "—"}</div>
          </div>
          <div>
            <div className="text-muted-foreground">Last login</div>
            <div className="font-medium">
              {lastLoginAt ? new Date(lastLoginAt).toLocaleString() : "—"}
            </div>
          </div>
          <div>
            <div className="text-muted-foreground">Session started</div>
            <div className="font-medium">
              {sessionStartedAt ? new Date(sessionStartedAt).toLocaleString() : "—"}
            </div>
          </div>
          <div className="flex gap-2 pt-2">
            <Button variant="outline" onClick={logout}>
              Logout
            </Button>
            <Button variant="ghost" asChild>
              <Link to="/admin">Back to dashboard</Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
